import React from "react"
import styles from "./WrapperInner.module.scss"
import classnames from "classnames/bind"

const WrapperInner = props => {
  return (
    <div className={classnames(styles.container, props.className)}>
      {props.children}
    </div>
  )
}

export default WrapperInner
